export const getTranslationKey = (key: string, translationPrefix?: string) => {
  return (translationPrefix ? `${translationPrefix}.` : '') + key
}
